import { useState } from "react";
import { MessageCircle, X, ShieldAlert } from "lucide-react";

const OPTIONS = [
  ["Apply for Support", "Hello DKF, I would like help applying for support."],
  ["Donation Question", "Hello DKF, I have a question about donating."],
  ["Application Status", "Hello DKF, I would like an update on my application. My serial number is: "],
  ["Partnership", "Hello DKF, I would like to discuss a partnership."],
  ["Emergency", "Hello DKF, I need to report an emergency: "],
  ["General Enquiry", "Hello DKF, I have a general enquiry."],
];

export default function WhatsAppFloating() {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed left-3 md:left-5 top-[calc(50%+12px)] z-50 flex flex-col md:flex-row-reverse items-start gap-3" data-testid="whatsapp-widget">
      {open && (
        <div className="w-[300px] max-md:fixed max-md:inset-x-3 max-md:bottom-4 max-md:w-auto bg-white rounded-2xl shadow-2xl border border-black/5 overflow-hidden" data-testid="whatsapp-menu">
          <div className="bg-[#155e3f] text-white p-4">
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#d6aa43] font-semibold">WhatsApp support</div>
            <div className="font-serif font-bold">How can we help?</div>
          </div>
          <ul className="p-2">
            {OPTIONS.map(([label, msg]) => (
              <li key={label}>
                <a href={`https://wa.me/2348063550963?text=${encodeURIComponent(msg)}`} target="_blank" rel="noopener noreferrer"
                  className="block px-3 py-2.5 rounded-md text-sm text-[#0a0d12] hover:bg-[#f8f4e8]" data-testid={`wa-option-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{label}</a>
              </li>
            ))}
          </ul>
          <div className="px-4 py-3 bg-[#f8f4e8] text-[11px] text-[#0a0d12]/80 flex gap-2" data-testid="wa-fraud-warning">
            <ShieldAlert size={14} className="text-[#d6aa43] shrink-0 mt-0.5" />
            DKF will never request your password, PIN or payment in exchange for application approval.
          </div>
        </div>
      )}
      <button onClick={() => setOpen((v) => !v)} aria-label={open ? "Close WhatsApp menu" : "Chat on WhatsApp"} aria-expanded={open}
        className="bg-[#25D366] text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg hover:scale-105 transition-transform" data-testid="whatsapp-floating-button">
        {open ? <X size={24} /> : <MessageCircle size={26} />}
      </button>
    </div>
  );
}
